import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { computed } from 'mobx';
import env from '../misc/env';
import { createIamAPI } from '../iam/API';

/**
 * Manages multi-factor authentication
 */
var MultiFactorAuthStore = (_class = /*#__PURE__*/function () {
  /**
   * Constructor.
   */
  function MultiFactorAuthStore(_ref) {
    var rootStore = _ref.rootStore;
    _classCallCheck(this, MultiFactorAuthStore);
    this.rootStore = rootStore;
    this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: this.rootStore.authStore.getToken
    });
  }

  /**
   * Determine whether the user is enrolled in multi-factor authentication.
   */
  return _createClass(MultiFactorAuthStore, [{
    key: "isUserEnrolled",
    get: function get() {
      var _this$rootStore$authS;
      return Boolean((_this$rootStore$authS = this.rootStore.authStore.user) === null || _this$rootStore$authS === void 0 ? void 0 : _this$rootStore$authS.multiFactorAuthenticationEnabled);
    }

    /**
     * Gets an MFA enrollment URL.
     */
  }, {
    key: "getEnrollmentUrl",
    value: function getEnrollmentUrl() {
      return this.api.auth.enrollMFA().then(function (r) {
        return r.enrollment_url;
      });
    }
  }]);
}(), _applyDecoratedDescriptor(_class.prototype, "isUserEnrolled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUserEnrolled"), _class.prototype), _class);
export { MultiFactorAuthStore as default };
//# sourceMappingURL=MultiFactorAuthStore.js.map
